export const cursorPositions = {
    START: 'start',
    END: 'end'
};
export default {
    cursorPositions
};
